import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaLock, FaInfoCircle, FaCheck, FaEye, FaEyeSlash } from 'react-icons/fa';
import Topbar from '../layouts/Topbar';
import Sidebar from '../layouts/Sidebar';
import './ChangePassword.css';
import { useNavigate } from 'react-router-dom';
const ChangePassword = () => {
    const baseUrl = "https://api.burrayhr.com";
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [passwordData, setPasswordData] = useState({
        old_password: '',
        new_password: '',
        confirm_password: ''
    });
    const [errors, setErrors] = useState({});
    const [showPasswords, setShowPasswords] = useState({
        old_password: false,
        new_password: false,
        confirm_password: false
    });

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            console.log(errors[name]);
            setErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    const validatePasswordChange = () => {
        const newErrors = {};
        if (!passwordData.old_password) newErrors.old_password = 'Current password is required';
        if (!passwordData.new_password) newErrors.new_password = 'New password is required';
        else if (passwordData.new_password.length < 8) newErrors.new_password = 'Password must be at least 8 characters';
        if (!passwordData.confirm_password) newErrors.confirm_password = 'Please confirm your password';
        else if (passwordData.new_password !== passwordData.confirm_password) {
            newErrors.confirm_password = 'Passwords do not match';
        }
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const validationErrors = validatePasswordChange();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${baseUrl}/api/change-password/`, passwordData, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Password changed successfully',
                confirmButtonColor: '#1e3a8a'
            });
            navigate('/admin-manager/dashboard');

            setPasswordData({
                old_password: '',
                new_password: '',
                confirm_password: ''
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.old_password || 'Failed to change password',
                confirmButtonColor: '#1e3a8a'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Topbar />
            <Sidebar />
            <div className="main-content">
                <div className="change-password-container">
                    <div className="settings-section">
                        <div className="section-header">
                            <h2>Change Password</h2>
                            <p>Update your account password</p>
                        </div>
                        <form onSubmit={handleSubmit} className="settings-form">
                            <div className="form-group">
                                <label htmlFor="current_password">
                                    <FaLock className="field-icon" />
                                    Current Password
                                </label>
                                <div className="password-input-wrapper">
                                    <input
                                        type={showPasswords.old_password ? 'text' : 'password'}
                                        id="old_password"
                                        name="old_password"
                                        value={passwordData.old_password}
                                        onChange={handlePasswordChange}
                                        className={errors.old_password ? 'error' : ''}
                                    />
                                    <button
                                        type="button"
                                        className="password-toggle"
                                        onClick={() => setShowPasswords(prev => ({ ...prev, old_password: !prev.old_password }))}
                                    >
                                        {showPasswords.old_password ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                                {errors.old_password && (
                                    <div className="error-message">
                                        <FaInfoCircle /> {errors.old_password}
                                    </div>
                                )}
                            </div>

                            <div className="form-group">
                                <label htmlFor="new_password">
                                    <FaLock className="field-icon" />
                                    New Password
                                </label>
                                <div className="password-input-wrapper">
                                    <input
                                        type={showPasswords.new_password ? 'text' : 'password'}
                                        id="new_password"
                                        name="new_password"
                                        value={passwordData.new_password}
                                        onChange={handlePasswordChange}
                                        className={errors.new_password ? 'error' : ''}
                                    />
                                    <button
                                        type="button"
                                        className="password-toggle"
                                        onClick={() => setShowPasswords(prev => ({ ...prev, new_password: !prev.new_password }))}
                                    >
                                        {showPasswords.new_password ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                                {errors.new_password && (
                                    <div className="error-message">
                                        <FaInfoCircle /> {errors.new_password}
                                    </div>
                                )}
                            </div>

                            <div className="form-group">
                                <label htmlFor="confirm_password">
                                    <FaLock className="field-icon" />
                                    Confirm New Password
                                </label>
                                <div className="password-input-wrapper">
                                    <input
                                        type={showPasswords.confirm_password ? 'text' : 'password'}
                                        id="confirm_password"
                                        name="confirm_password"
                                        value={passwordData.confirm_password}
                                        onChange={handlePasswordChange}
                                        className={errors.confirm_password ? 'error' : ''}
                                    />
                                    <button
                                        type="button"
                                        className="password-toggle"
                                        onClick={() => setShowPasswords(prev => ({ ...prev, confirm_password: !prev.confirm_password }))}
                                    >
                                        {showPasswords.confirm_password ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                                {errors.confirm_password && (
                                    <div className="error-message">
                                        <FaInfoCircle /> {errors.confirm_password}
                                    </div>
                                )}
                            </div>
                            <button 
                                type="submit" 
                                className="submit-button" 
                                disabled={loading}
                            >
                                {loading ? 'Changing Password...' : 'Change Password'} <FaCheck />
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword; 